// import React, { useEffect, useState } from "react";
// import { getIn } from "formik";
// import {
//     Box,
//     IconButton,
//     Typography,
//     FormControl,
//     CircularProgress,
//     Stack
// } from "@mui/material";
// import DescriptionIcon from "@mui/icons-material/Description";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import ClearIcon from '@mui/icons-material/Clear';

// export const FileUploadFormField = ({ field, form, label, isRequired, ...props }) => {
//     const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
//     const [fileName, setFileName] = useState(field.value?.name || null);
//     const [isUploading, setIsUploading] = useState(false);
//     const [error, setError] = useState(getIn(form.errors, field.name));

//     const handleUpload = async (event) => {
//         if (!event.target.files) return;

//         setError("");
//         const file = event.target.files[0];
//         if (!file) return;

//         const allowedTypes = [
//             "application/pdf",
//             "application/msword",
//             "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//         ];

//         if (!allowedTypes.includes(file.type)) {
//             setError("Only PDF, DOC, or DOCX files are allowed.");
//             return;
//         }

//         const maxSize = 5 * 1024 * 1024; // 5MB
//         if (file.size > maxSize) {
//             setError("File size should be less than 5MB.");
//             return;
//         }

//         setIsUploading(true);
//         setTimeout(() => {
//             form.setFieldValue(field.name, file);
//             setFileName(file.name);
//             setIsUploading(false);
//         }, 2000);
//     };

//     const handleRemove = () => {
//         setFileName(null);
//         form.setFieldValue(field.name, "");
//     };

//  useEffect(() => {
//     if (!field.value) {
//       setFileName(null);
//     }
//   }, [field.value]);

//     return (
//         <>
//             <FormControl
//                 fullWidth
//                 sx={{
//                     border: "1px dashed #DC143C",
//                     borderRadius: "10px",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     py: "16px",
//                     textAlign: "center",
//                 }}
//             >
//                 <Box display="flex" flexDirection="column" alignItems="center" gap={1}>

//                     {
//                         isUploading ? <CircularProgress size={40} sx={{ mt: 1, color: "#000" }} /> : !fileName ? <>
//                             <IconButton
//                                 component="label"
//                                 sx={{
//                                     bgcolor: "red.light",
//                                     borderRadius: "50%",
//                                     padding: 2,
//                                     '&:hover': {
//                                         bgcolor: "red.light"
//                                     }
//                                 }}
//                             >
//                                 <UploadFileIcon sx={{ fontSize: "24px", color: "#DC143C" }} />
//                                 <input
//                                     type="file"
//                                     accept=".pdf,.doc,.docx"
//                                     hidden
//                                     onChange={handleUpload}
//                                 />
//                             </IconButton>
//                             <Typography variant="body2" >
//                                 {label}
//                             </Typography>
//                         </> : <Stack direction="row" alignItems="center" gap={1} position="relative">

//                             <DescriptionIcon sx={{ fontSize: "40px", color: "#4169E1" }} />
//                             <Typography variant="body2" color="#000">
//                                 {fileName}
//                             </Typography>
//                             <IconButton
//                                 sx={{
//                                     p: 0,
//                                     ml: 1,
//                                     bgcolor: "rgba(255, 255, 255, 0.7)",
//                                 }}
//                                 onClick={handleRemove}
//                             >
//                                 <ClearIcon sx={{ fontSize: "20px", color: "#000" }} />
//                             </IconButton>
//                         </Stack>
//                     }
//                 </Box>
//             </FormControl>
//             {error && (
//                 <Typography variant="h6" fontSize={"10px"} color="red">
//                     {error}
//                 </Typography>
//             )}
//             {errorText && (
//                 <Typography variant="h6" fontSize={"10px"} color="red">
//                     {errorText}
//                 </Typography>
//             )}
//         </>
//     );
// };



import React, { useEffect, useState } from "react";
import { getIn } from "formik";
import {
  Box,
  IconButton,
  Typography,
  FormControl,
  CircularProgress,
  Stack,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ClearIcon from "@mui/icons-material/Clear";

export const FileUploadFormField = ({
  field,
  form,
  label,
  isRequired,
  ...props
}) => {
  const formikError = getIn(form.touched, field.name) && getIn(form.errors, field.name);
  const [fileName, setFileName] = useState(field.value?.name || null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState("");

  const handleUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setError("");

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedTypes.includes(file.type)) {
      setError("Only PDF, DOC, or DOCX files are allowed.");
      return;
    }

    const maxSize = 2 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      setError("File size should be less than 2MB.");
      return;
    }

    setIsUploading(true);

    // Simulate upload delay
    setTimeout(() => {
      form.setFieldValue(field.name, file);
      setFileName(file.name);
      setIsUploading(false);
    }, 2000);
  };

  const handleRemove = () => {
    setFileName(null);
    form.setFieldValue(field.name, "");
  };

  useEffect(() => {
    if (!field.value) {
      setFileName(null);
    }
  }, [field.value]);

  return (
    <>
      <FormControl
        fullWidth
        sx={{
          border: "1px dashed #DC143C",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: "16px",
          textAlign: "center",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          {isUploading ? (
            <CircularProgress size={40} sx={{ mt: 1, color: "#000" }} />
          ) : !fileName ? (
            <>
              <IconButton
                component="label"
                sx={{
                  bgcolor: "red.light",
                  borderRadius: "50%",
                  p: 2,
                  "&:hover": { bgcolor: "red.light" },
                }}
              >
                <UploadFileIcon sx={{ fontSize: 24, color: "#DC143C" }} />
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  hidden
                  onChange={handleUpload}
                />
              </IconButton>
              <Typography variant="body2">
                {label} {isRequired && <span style={{ color: "red" }}>*</span>}
              </Typography>
            </>
          ) : (
            <Stack direction="row" alignItems="center" gap={1}>
              <DescriptionIcon sx={{ fontSize: 40, color: "#4169E1" }} />
              <Typography variant="body2" color="#000">
                {fileName}
              </Typography>
              <IconButton
                sx={{
                  p: 0,
                  ml: 1,
                  bgcolor: "rgba(255, 255, 255, 0.7)",
                }}
                onClick={handleRemove}
              >
                <ClearIcon sx={{ fontSize: 20, color: "#000" }} />
              </IconButton>
            </Stack>
          )}
        </Box>
      </FormControl>

      {(error || formikError) && (
        <Typography variant="caption" color="red" mt={0.5}>
          {error || formikError}
        </Typography>
      )}
    </>
  );
};
